import { baseUrl } from 'infra/config/aws-env'
import { ExploreService } from 'infra/services/explore-service'
import { makeAxiosHttpClient } from '../http/axios-http-client-factory'

export const makeExploreService = (): ExploreService => new ExploreService(baseUrl, makeAxiosHttpClient())
